import { useContext } from 'react'
import SbUtils from '../../../Utils/SbUtils'
import Type from '../../Common/Type';
import DashboardScreenContext from '../../Context/DashboardScreenContext'

const SelectFeedTypeSection = ( props ) => {

    const {
        feedTypes,
        upsellModal
    } = useContext( DashboardScreenContext );


    return (
        <div className='sb-creationprocess-content sb-fs'>
            <div className='sb-types-list sb-fs'>
                {
                    feedTypes.map( ( feedType, feedTypeInd ) => {
                        const isFeedTypePro = SbUtils.checkSettingIsPro( feedType.upsellModal );
                        return(
                            <Type
                                key={ feedTypeInd }
                                type={ feedType.type }
                                title={ feedType.title }
                                info={ feedType.info }
                                isChecked={ props.selectedFeedType === feedType.type}
                                isFeedTypePro={ isFeedTypePro }
                                onClick={ () => {
                                    if( isFeedTypePro === false  ){
                                        props.selectFeedTypeAction( feedType.type )
                                    }else{
                                        SbUtils.openUpsellModal( feedType.upsellModal, upsellModal )
                                    }
                                } }
                            />
                        )
                    } )
                }
            </div>
        </div>
    )
}

export default SelectFeedTypeSection;